/** Central place for third-party IDs used by `ThirdPartyScripts`. */

export type TrackingIds = {
  gtmId: string;
  gaMeasurementId: string;
  awConversionId: string;
};

const PRODUCTION: TrackingIds = {
  gtmId: 'GTM-PPL9QM8',
  gaMeasurementId: 'G-4GP1ZDD634',
  awConversionId: 'AW-18389080678',
};

const DEVELOPMENT: TrackingIds = {
  gtmId: 'GTM-M9ZR99R',
  gaMeasurementId: 'G-MP2N873P2L',
  awConversionId: 'AW-18389080678',
};

export const HUBSPOT_SCRIPT_SRC = 'https://js-na2.hs-scripts.com/243596693.js';

export function getTrackingIds(): TrackingIds {
  return process.env.NEXT_PUBLIC_APP_IS_PRODUCTION === 'true' ? PRODUCTION : DEVELOPMENT;
}
